/** Return a safe in-app path for post-auth redirects. */
export function safeNextPath(raw) {
  if (!raw || typeof raw !== 'string') return '/dashboard';
  const path = raw.startsWith('/') ? raw : `/${raw}`;
  if (!path.startsWith('/') || path.startsWith('//')) return '/dashboard';
  return path;
}

export function isBrowseIntent(next) {
  const path = safeNextPath(next);
  return path === '/properties'
    || path.startsWith('/properties/')
    || path === '/neighbourhood'
    || path.startsWith('/neighbourhood/');
}
